const PublicFallback = () => (
    <div style={{ padding: "2rem", textAlign: "center" }}>
      <h2>ページが見つかりません</h2>
      <p>URLをご確認ください。</p>
      <a href="/">トップページへ戻る</a>
    </div>
  );
  
  export default PublicFallback;
  